import refs from '../helpers/refs'

class CSliderSocialEmbed {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-slider-social-embed')
    .forEach(el => new CSliderSocialEmbed(el))
})
